import React from 'react'
import {
  NodeMenu,
  EdgeMenu,
  GroupMenu,
  MultiMenu,
  CanvasMenu,
  ContextMenu,
} from 'gg-editor'
import MenuItem from './MenuItem'
import './index.scss'

const FlowContextMenu = (props) => {
  return (
    <ContextMenu className="contextMenu">
      <NodeMenu>
        {/* click Task */}

        <MenuItem command="copy" />

        <div hidden={props.hiddenDelete}>
          <MenuItem command="delete" />
        </div>
      </NodeMenu>
      <EdgeMenu>
        {/* click Line */}
        <MenuItem command="delete" />
      </EdgeMenu>
      <GroupMenu>
        <MenuItem command="copy" />
        <MenuItem command="delete" />
        <MenuItem command="unGroup" icon="ungroup" text="Ungroup" />
      </GroupMenu>
      <MultiMenu>
        <MenuItem command="copy" />
        <MenuItem command="paste" />
        <MenuItem command="addGroup" icon="group" text="Add Group" />
        <MenuItem command="delete" />
      </MultiMenu>
      <CanvasMenu>
        {/*click Background */}
        {/* <MenuItem command="undo" />
        <MenuItem command="redo" /> */}

        <MenuItem command="pasteHere" icon="paste" text="Paste Here" />
      </CanvasMenu>
    </ContextMenu>
  )
}

export default FlowContextMenu
